// Module
var code = "<preferences-sidebar></preferences-sidebar> <ui-view></ui-view> ";
// Exports
module.exports = code;